import {
  getTransport,
  createTransport,
  updatePatchTransport,
  updatePutTransport,
  deleteTransport,
  
  
  
  getTransportCategory,
  createTransportCategory,
  updatePatchTransportCategory,
  updatePutTransportCategory,
  deleteTransportCategory,
} from '@/api/reference'

export default {
  CREATE_TRANSPORT(_, data) {
    return createTransport(data)
  },
  FETCH_TRANSPORT({ commit }, params) {
    return getTransport(params)
      .then(res => {
        commit('SET_TRANSPORT', res.data)
      })
  },
  UPDATE_PATCH_TRANSPORT(_, data) {
    return updatePatchTransport(data)
  },
  UPDATE_PUT_TRANSPORT(_, data) {
    return updatePutTransport(data)
  },
  DELETE_TRANSPORT(_, id) {
    return deleteTransport(id)
  },
  
  
  
  
  
  
  CREATE_TRANSPORT_CATEGORY(_, data) {
    return createTransportCategory(data)
  },
  FETCH_TRANSPORT_CATEGORY({ commit }, params) {
    return getTransportCategory(params)
      .then(res => {
        commit('SET_TRANSPORT_CATEGORY', res.data)
      })
  },
  UPDATE_PATCH_TRANSPORT_CATEGORY(_, data) {
    return updatePatchTransportCategory(data)
  },
  UPDATE_PUT_TRANSPORT_CATEGORY(_, data) {
    return updatePutTransportCategory(data)
  },
  DELETE_TRANSPORT_CATEGORY(_, id) {
    return deleteTransportCategory(id)
  },
}
